const _ = require('lodash');
let _rrPubSub, _user;

function SavedListsService(restangular, $rootScope, $q, bootstrap, RRPubSub, CurrentUserService, decorateAdditionalDetails) {
    _rrPubSub = RRPubSub;
    _user = CurrentUserService.get();
    this._edrProductsRoute = restangular.one('edr');
    this._savedListsRoute = restangular.one('mylists');
    this.restangular = restangular;
    this.savedLists = undefined;
    this.myListsMode = '';
    this.listName = '';
    this.listId = undefined;
    this.watchlistCount = undefined;
    this._decorator = decorateAdditionalDetails;

    this.pendingSaveToList = {
        isPending: false,
        stockcode: '',
        listName: '',
        stateName: ''
    };

    this.result = { Success: false, Message: '' };
    this.selectedList = null;
    this.selectedListProductsCount = 0;
    this.$rootScope = $rootScope;
    this.isListEmpty = undefined;
    this._savedListsPromise = null;

    if (bootstrap.isBootstrapped(bootstrap.bootstrapped.SavedLists)) {
        // we do this instead of invalidating on login because sometimes the saved lists service hasn't been
        // instantiated before the login event, meaning we can't call invalidate and the incorrect bootstrapped data
        // will be loaded.
        const bootstrappedSavedLists = bootstrap.getBootstrappedData(bootstrap.bootstrapped.SavedLists);
        if (bootstrappedSavedLists.Response.length > 0) {
            this._savedListsPromise = $q
                .when(bootstrap.getBootstrappedData(bootstrap.bootstrapped.SavedLists))
                .then(this._setSavedLists.bind(this));
        }
    }
}

SavedListsService.prototype._setSavedLists = function (data) {
    this.savedLists = data.Response;
    return self.savedLists;
};

SavedListsService.prototype.listSavedLists = function () {
    if (this._savedListsPromise) {
        return this._savedListsPromise;
    }

    this._savedListsPromise = this._savedListsRoute.get().then(this._setSavedLists.bind(this));

    return this._savedListsPromise;
};

SavedListsService.prototype.selectList = function (listProductsService, freeTextTagsService, listId) {
    const self = this;
    self.selectedList = _.find(self.savedLists, { ListId: parseInt(listId) });
    self.isListEmpty = false;
    self.listId = listId;
    self.selectedListProductsCount = self.selectedList.ProductsCount;
    self.myEDRselected = false;
    listProductsService.suggestedListClickedPreviously = false;
    freeTextTagsService.getTagsFor(listId);
    self.restangular.one('mylists', self.listId)
        .doGET('products')
        .then(function (response) {
            self.isListEmpty = !(response && response.Items.length > 0);
        });
};

SavedListsService.prototype.selectEDRList = function (listProductsService) {
    this.listId = 'MyWoolworthsRewards';
    this.selectedList = null;
    self.selectedListProductsCount = 0;
    self.myEDRselected = true;
    listProductsService.suggestedListClickedPreviously = false;
    self.isListEmpty = false;
};

SavedListsService.prototype.getProductsForSelectedList = function (args) {
    const self = this;
    const request = {
      PageNumber: args.PageNumber || 0,
      PageSize: args.PageSize || 10
    };

    const promise = (self.listId === 'MyWoolworthsRewards')
        ? self._edrProductsRoute.doGET('Products').then(function (response) {
            self.isListEmpty = false;
            return response;
        })
        : self.restangular.one('watchlist').doGET('items', request).then((response) => {
            if (args.PageNumber === 1) {
                self.isListEmpty = (response.Items.length === 0);
            }

            _.each(response.Items, (bundle) => {
               this._decorator(bundle.Products);
            });

            return response;
        });
    return promise.then(function (response) {
        return {
            items: response.Items,
            totalRecordCount: response.TotalRecordCount
        };
    });
};

SavedListsService.prototype.checkIfDefaultListEmpty = function () {
    const self = this;
    return self.restangular.one('mylists', self.listId)
        .doGET('products')
        .then(function (response) {
            return !(response && response.Items.length > 0);
        });
};

SavedListsService.prototype.updateList = function (id, name) {
    return this._savedListsRoute.one('edit').doPOST({ Id: id, Name: name }).then(this.invalidate.bind(this));
};

SavedListsService.prototype.setDefaultList = function (listId) {
    return this._savedListsRoute.one('setdefaultlist', listId).doPOST().then(this.invalidate.bind(this));
};

SavedListsService.prototype.deleteList = function (listId) {
    return this._savedListsRoute.one('deleteList', listId).doPOST().then(this.invalidate.bind(this));
};

SavedListsService.prototype.clearList = function (listId) {
    const self = this;
    return self._savedListsRoute.one('clearlist', listId).doPOST().then(function () {
        self.selectedListProductsCount = 0;
        self.$rootScope.$broadcast('savedList:clear');
    });
};

SavedListsService.prototype.addToList = function (stockcode, quantity, product) {
    return this.restangular.withConfig(function (RestangularConfigurer) {
        RestangularConfigurer.setFullResponse(true);
      }).one('watchlist').post('Items', { StockCode: stockcode, Quantity: quantity })
        .then(this.notifyRR.bind(this, { Stockcode: stockcode, Quantity: quantity, Price: product.Price, Name: product.Name }))
        .then(this.invalidate.bind(this)); // TODO: Speak to Dayne and Francis not sure why this needs be invalidated
};

SavedListsService.prototype.removeFromWatchList = function (stockcode) {
    const self = this;
    return this.restangular.one('watchlist').one('Items', stockcode).remove({}).then(function () {
      self.$rootScope.$broadcast('savedList:remove', stockcode);
    });
};

SavedListsService.prototype.setHideCheckedFreeTextTags = function (hideChecked) {
    return this._savedListsRoute.one('sethidecheckedfreetext').doPOST({ Id: this.listId, HideChecked: hideChecked });
};

SavedListsService.prototype.isHideCheckedFreeTextTags = function () {
    return this._savedListsRoute.one('gethidecheckedfreetext').get({ Id: this.listId });
};

SavedListsService.prototype.saveNewList = function (name) {
    return this._savedListsRoute.one('add').doPOST({ Name: name }).then(this.invalidate.bind(this));
};

SavedListsService.prototype.getList = function () {
    return this._savedListsRoute.get().then((data) => {
        this.watchlistCount = data.Response[0].ProductsCount;

        return data;
    });
};

SavedListsService.prototype.getDefaultListId = function () {
    return this._savedListsRoute.one('DefaultListId').get();
};

SavedListsService.prototype.resetPendingSaveToList = function () {
    this.pendingSaveToList = {
        isPending: false,
        stockcode: '',
        listName: '',
        stateName: ''
    };
};

SavedListsService.prototype.invalidate = function (arg) {
    this._savedListsPromise = null;
    this.savedLists = [];
    return arg;
};

SavedListsService.prototype.refresh = function (arg) {
    this.invalidate(arg);
    return this.listSavedLists();
};

// Inform Richer Relevance that a new product has been
// added to the watch list
SavedListsService.prototype.notifyRR = function (product, arg) {
    _rrPubSub.publish(_rrPubSub.EVENTS.ADD_TO_WISHLIST, { id: product.Stockcode, price: product.Price, qty: product.Quantity, shopperId: _user.id, name: product.Name });
    return arg;
};

module.exports = SavedListsService;



/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/savedlists/saved-lists-service.js
 **/